(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cart-drawer_items"] && !Shopify.designMode) return;
  try {
    (function () {
  if (customElements.get('cart-line-toggle')) return;
  customElements.define('cart-line-toggle', class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      var btn = this.querySelector('.cart-line-toggle__btn');
      if (!btn) return;
      var self = this;
      btn.addEventListener('click', function () {
        var scope = self.closest('.cart-item') || self.parentNode;
        var expanded = self.classList.toggle('is-expanded');
        Array.prototype.forEach.call(scope.querySelectorAll('.cart-line-prop--extra'), function (el) {
          el.classList.toggle('hidden', !expanded);
        });
        var more = self.querySelector('.cart-line-toggle__more');
        var less = self.querySelector('.cart-line-toggle__less');
        if (more) more.classList.toggle('hidden', expanded);
        if (less) less.classList.toggle('hidden', !expanded);
      });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
